import { QueryClient } from "@tanstack/react-query";
import { HttpError } from "@gain/common-client/browser";

const MAX_RETRIES = 1;
const MAX_RETRY_DELAY_MS = 5_000;

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (
    error instanceof HttpError &&
    (error.status === 501 || (error.status >= 400 && error.status < 500))
  ) {
    return false;
  }
  return failureCount < MAX_RETRIES;
}

export function retryDelay(attempt: number): number {
  return Math.min(1_000 * 2 ** attempt, MAX_RETRY_DELAY_MS);
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: shouldRetry,
      retryDelay,
    },
    mutations: {
      retry: 0,
    },
  },
});
